
<div class="container-fluid"  style="background: #F6F6F6;">
    <div class="container py-3" >
        <div class="row d-flex justify-content-around">
            <div class="col-12 col-md-3">
                <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-center fw-bold">
                        <mat-icon style="color: #00A384;">search</mat-icon>ARTICULO
                    </div>
                    <div class="card-body">
                        <div class="col-12">
                            <input class="form-control mr-sm-2"  [(ngModel)]="strBusqueda" type="search" placeholder="Buscar" aria-label="Search">
                        </div>
                    </div>
                  </div>
            </div>
            <div class="col-12 col-md-3">
                <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-center fw-bold">
                        <mat-icon style="color: #00A384;">navigation</mat-icon> ORIGEN
                    </div>
                    <div class="card-body">
                        <select class="custom-select" id="inputGroupSelect01" [(ngModel)]="almacenOrigen">
                            <option value="-1" selected >--Todos--</option>
                            <option value="{{A.strAlmacen}}" *ngFor="let A of arrayAlmacen">{{A.strNombreAlm}}</option>
                        </select>
                    </div>
                  </div>
            </div>
            <div class="col-12 col-md-3">
                <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-center fw-bold">
                        <mat-icon style="color: #00A384;">pin_drop</mat-icon> DESTINO
                    </div>
                    <div class="card-body">
                        <select class="custom-select" id="inputGroupSelect01" [(ngModel)]="almacenDestino">
                            <option value="-1" selected >--Todos--</option>
                            <option value="{{A.strAlmacen}}" *ngFor="let A of arrayAlmacen">{{A.strNombreAlm}}</option>
                        </select>
                    </div>
                  </div>
            </div>


            <div class="col-12 col-md-2">
                <div class="card ">
                    <div class="card-header  d-flex align-items-center justify-content-center fw-bold">
                        <mat-icon  style="color: #00A384;">cloud_download</mat-icon>  DESCARGAR
                    </div>
                    <div class="card-body " >
                        <div class="text-center" *ngIf="spiner" >
                            <img  src="assets/img/cargando.gif"alt="" class="h-50">
                        </div>
                            <div *ngIf="!spiner" class="col-12 text-center d-flex justify-content-center">
                                <button (click)="exportToExcel()" class="btn text-success p-0"><i class="fa-solid fa-file-excel h2 mb-0"></i></button>
                            </div>
                    </div>
               </div>
            </div>
            
           
        </div>
        <div class="row">
            <div class="col-12 table-responsive">
                <div *ngFor="let A of almacenes|filtrarAlmOrigenDestino:almacenOrigen:almacenDestino; let i=index;" class="my-5">
                    <div *ngIf="A.arrayresult.length>0 && (A.arrayresult | filtrarAlmArticulos: strBusqueda).length > 0 " class="row d-flex justify-content-center pb-2 mx-0" >
                        <div class="d-flex justify-content-center">
                            <label for="" class=" d-flex align-items-center bg-light mb-0 mr-2  shadow p-1 rounded text-dark font-weight-light"> Origen:
                                <label class="  mb-0 text-dark rounded p-1 fw-bold">
                                        ({{A.strAlm_Origen}}) {{A.strAlm_OrigenNombre}}
                                </label>
                            </label>
                            <label for="" class=" d-flex align-items-center bg-light mb-0 shadow p-1 ml-2 rounded text-dark font-weight-light"> Destino:
                                <label class="  mb-0 text-dark rounded p-1 fw-bold">
                                        ({{A.strAlm_destino}}) {{A.strAlm_destinoNombre}}
                                </label>
                            </label>
                        </div>
                    </div>
                    <div *ngIf="A.arrayresult.length>0 && (A.arrayresult | filtrarAlmArticulos: strBusqueda).length > 0 " class="tableh">
                    <table class="mb-0 table table-striped table-bordered">
                        <thead>
                            <tr class="thcenter fijetop ">
                                <th>Articulo</th>
                                <th>Linea</th>
                                <th>Opcion</th>
                                <th>Cantidad</th>
                                <th>Volumen</th>
                                <th>Total Volumen</th>
                            </tr>
                        </thead>
                        <tbody><!--*ngFor="let objeto of objetosAgrupadosPorLinea[linea]"-->
                            <tr *ngFor="let objeto of A.arrayresult| filtrarAlmArticulos: strBusqueda;">
                                <td class="text-center">{{ objeto.strArticulo }}</td>
                                <td class="text-center">{{ objeto.strLinea }}</td>
                                <td class="text-center">{{ objeto.strOpcion }}</td>
                                <td class="thright">{{ objeto.dblCantidad }}</td>
                                <td class="thright">{{ objeto.dblVolumen | number:'1.2-2'}}</td>
                                <td class="thright">{{ objeto.dblVolumen * objeto.dblCantidad | number:'1.2-2'}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="fijebot">
                                <td colspan="3" class="fw-bold"> Total</td>
                                <td class="thright fw-bold">{{fnsumarCantidad(A.strAlm_Origen,A.strAlm_destino)}}</td>
                                <td class="thright fw-bold">{{fnsumarVolumen(A.strAlm_Origen,A.strAlm_destino)| number:'1.2-2'}} m<sup class="superscript">3</sup></td>
                                <td class="thright fw-bold">{{fnsumarVolumenT(A.strAlm_Origen,A.strAlm_destino)| number:'1.2-2'}} m<sup class="superscript">3</sup></td>
                            </tr>
                        </tfoot>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>